import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export const ROLE_COMMUNITIES_RESOURCE = 'roleCommunities';

const roleCommunitiesService = ComposedComponent =>
  reduxFetch([
    {
      resource: ROLE_COMMUNITIES_RESOURCE,
      method: 'get',
      request: (appId, installationId, featureId, roleId) => ({
        url: apiRoutes.roleCommunities(appId, installationId, featureId, roleId),
      }),
    },
  ])(ComposedComponent);

export default roleCommunitiesService;
